import Menu from './Menu/Menu.vue';
import NavButton from './NavButton/NavButton.vue';
import messages from '../assets/generated/i18n/i18n.json';

const LoginNav = {
  name: 'LoginNav',
  components: {
    Menu,
    NavButton
  },
  props: {
    /**
     * An object of excluded items keys
    */
    itemsExcluded: {
      type: Object,
      default() {
        return {
          connected: [],
          disconnected: []
        };
      }
    },
    /**
     * User is online or not.
     * This value has an impact on the rendered list.
    */
    isConnected: {
      type: [Boolean, String],
      default: false
    },
    /**
     * State is Loading .
     * passe to false whene api call is done.
    */
    isLoading: {
      type: Boolean,
      default: true
    },
    /**
     * User is member or not.
    */
    isMember: {
      type: [Boolean, String],
      default: false
    },
    /**
     * An object or string nullable containing the user info.
     * { points: number, statut: string, username: string }
    */
    statusInfo: {
      type: [Object, String],
      default: null,
    },
    /**
     * actionCallbacks property takes some key property to be handle in sub component.
    */
    actionCallbacks: {
      type: Object,
      default: null
    },
    /**
     * An object to pass a custom list.
     * By default the list is retrieved from the i18n csv.
    */
    itemList: {
      type: Object,
      default: () => {},
    },
    /**
     * Text holder for the nav Button.
     * By default the value is retrieved from the i18n csv.
    */
    navButtonLabel: {
      type: String,
      default: '',
    },
    /**
     * sr-only text for the nav button.
     * By default, the text is retrieved from the i18n csv.
    */
    ariaLabelNavButton: {
      type: String,
      default: '',
    },
    /**
     * sr-only text for the close button.
     * By default, the text is retrieved from the i18n csv.
    */
    closeA11y: {
      type: String,
      default: '',
    },

    lang: {
      type: String,
      default: 'en',
    }
  },
  data() {
    return {
      LoginNavList: {},
      isOpen: false,
    };
  },
  computed: {
    exclusionKeysItems : function () {
      if(this.isConnected) {
        return this.itemsExcluded.connected;
      }
      return this.itemsExcluded.disconnected;
    },
    computeItemList : function () {
      const newListItemDisconnected = this.LoginNavList.menu.disconnected;
      const newListItemConnected = this.LoginNavList.menu.connected;
      if(this.isConnected) {
        if(!this.isMember) {
          const newListItemConnectedJoin = { ...newListItemConnected };
          delete newListItemConnectedJoin.status;
          delete newListItemConnectedJoin.reward;
          return  this.mapAndExcludeData({ loyaltyCard:newListItemDisconnected.loyaltyCard, join: newListItemDisconnected.join, ...newListItemConnectedJoin});
        }
        return  this.mapAndExcludeData(newListItemConnected);
      } else {
        return this.mapAndExcludeData(newListItemDisconnected);
      }
    },
    dfltAriaLabelNavButton : function() {
      return this.ariaLabelNavButton || this.LoginNavList.menu.nav.ariaLabel;
    },
    dfltcloseA11y : function() {
      return this.closeA11y || this.LoginNavList.menu.close;
    },
    dfltnavButtonLabel : function() {
      return this.isConnected ? this.statusInfo.username :  (this.navButtonLabel || this.LoginNavList.menu.nav.buttonText);
    },
    trackingEnLabel: function () {
      return messages['en'].menu[this.isConnected ? 'connected' : 'disconnected'];
    }
  },
  created() {
    if(this.itemList && Object.keys(this.itemList).length) {
      this.LoginNavList = this.itemList;
    }
    else {
      this.LoginNavList = messages[this.lang];
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      if (!this.$el.contains(event.target) && this.isOpen) {
        this.toggleLoginNav();
      }
    },
    mapAndExcludeData: function (object) {
      const ObjectKeys = Object.keys(object).filter((key) => !this.exclusionKeysItems.includes(key));
      return ObjectKeys.map((elem) => {
        return {
          key: elem,
          link: object[elem].link ? object[elem].link.replaceAll('${site}', this.getBrandName()) : null,
          text: object[elem].text || null,
          title: object[elem].title || null,
          type: object[elem].type || null,
          wordings: object[elem].wordings || null,
          highlight: object[elem].highlight || false,
          separated: object[elem].separated || null,
          textBis: object[elem].textBis ? object[elem].textBis : null,
        };
      });
    },
    getBrandName: function () {
      const brandName = location.hostname.split('.')[0];
      return (brandName === 'businesstravel' || brandName === 'meetings' || brandName === 'travelpros') ? brandName : 'accor';
    },
    toggleLoginNav: function () {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        let openEventGlobal = new CustomEvent('login-connect:open');
        document.dispatchEvent(openEventGlobal);
        /**
         * This event is emited when we click on an item.
         * The payload contains the key of the clicked item.
        */
        this.$emit('clickOnItem', {key: 'menu', label:'show menu', position: '0'});
      } else {
        let closeEventGlobal = new CustomEvent('login-connect:close');
        document.dispatchEvent(closeEventGlobal);
        /**
         * This event is emited when we close the login nav.
        */
        this.$emit('closeLoginNav', true);
      }
    },
    closeLoginNav: function () {
      this.isOpen = false;
    },
    navBtnFocus() {
      if (this.$children[0].$refs.navBtn) {
        this.$children[0].$refs.navBtn.focus();
      }
    },
    clickOnItem: function (key) {
      this.$emit('clickOnItem', key);
    },
    isRTL() {
      if ((this.lang === 'ar') ||
        document.querySelector('html').dir === 'rtl' ||
        document.querySelector('html').lang === 'ar'
      ) {
        return true;
      }
      return false;
    },
  },
};

export default LoginNav;
